import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "m-header"
}
const _hoisted_2 = { class: "m-title" }
const _hoisted_3 = { class: "m-body" }
const _hoisted_4 = {
  key: 1,
  class: "m-footer"
}

import { computed, onBeforeUnmount, watch } from "vue";

type CloseReason = "overlay" | "esc" | "button" | "program";


export default /*@__PURE__*/_defineComponent({
  __name: 'CommonModal',
  props: {
    modelValue: { type: Boolean },
    title: {},
    closeOnOverlay: { type: Boolean, default: true },
    closeOnEsc: { type: Boolean, default: true },
    lockScroll: { type: Boolean, default: true },
    width: { default: "560px" }
  },
  emits: ["update:modelValue", "open", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const isOpen = computed(() => props.modelValue);

const cardWidth = computed(() => {
  const w = props.width;
  return typeof w === "number" ? `${w}px` : w;
});

const cardStyle = computed(() => ({
  width: `min(${cardWidth.value}, 100%)`,
}));

let mouseDownOnOverlay = false;

function setBodyLock(locked: boolean) {
  if (!props.lockScroll) return;
  document.body.style.overflow = locked ? "hidden" : "";
}

function close(reason: CloseReason = "program") {
  emit("close", reason);
  emit("update:modelValue", false);
}

function onOverlayMouseDown(e: MouseEvent) {
  mouseDownOnOverlay = e.target === e.currentTarget;
}

function onOverlayMouseUp() {
  if (props.closeOnOverlay && mouseDownOnOverlay) {
    close("overlay");
  }
  mouseDownOnOverlay = false;
}

function onKeydown(e: KeyboardEvent) {
  if (!props.closeOnEsc) return;
  if (e.key === "Escape" && isOpen.value) close("esc");
}

watch(
  isOpen,
  (v) => {
    if (v) {
      emit("open");
      setBodyLock(true);
      window.addEventListener("keydown", onKeydown);
    } else {
      setBodyLock(false);
      window.removeEventListener("keydown", onKeydown);
    }
  },
  { immediate: true }
);

onBeforeUnmount(() => {
  setBodyLock(false);
  window.removeEventListener("keydown", onKeydown);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal-fade" }, {
      default: _withCtx(() => [
        (isOpen.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "m-overlay",
              onMousedown: onOverlayMouseDown,
              onMouseup: onOverlayMouseUp
            }, [
              _createElementVNode("div", {
                class: "m-card",
                role: "dialog",
                style: _normalizeStyle(cardStyle.value),
                "aria-modal": "true",
                onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                onMouseup: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
              }, [
                (__props.title)
                  ? (_openBlock(), _createElementBlock("header", _hoisted_1, [
                      _createElementVNode("h3", _hoisted_2, _toDisplayString(__props.title), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                  _renderSlot(_ctx.$slots, "default")
                ]),
                (_ctx.$slots.footer)
                  ? (_openBlock(), _createElementBlock("footer", _hoisted_4, [
                      _renderSlot(_ctx.$slots, "footer")
                    ]))
                  : _createCommentVNode("", true)
              ], 36)
            ], 32))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ]))
}
}

})